import React, {Component} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from 'styled-components';
import { TextBox } from '../Shared/FormHelpers'
import { ButtonStyle } from '../Styles';
import {
  createAlert as createAlertAction,
  updateAlert as updateAlertAction,
} from "../../redux/middleware/user";

const Container = styled.form`
  color: #8290a2;
  padding: 0 0 0 20px;
  label {
    font-weight: 500;
  }
  input[type=checkbox], input[type=radio] {
    margin: 4px 10px 0 0;
    margin-top: 1px\9;
    line-height: normal;
  }
  select {
    height: 48px;
    margin-bottom: 10px;
  }
  input[type=file] {
    height: 48px;
    margin-bottom: 10px;
  }
  @media screen and (max-width: 767px) {
    padding: 0;
  }
`;

const Header = styled.h1`
  width: 100%;
  float: left;
  margin: 15px 0 20px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  border-bottom: 1px solid #8da3aa;
  padding-bottom: 15px;
`;

const Button = styled(ButtonStyle)`
  float: right;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const Status = styled.div`
  float: left;
  margin-top: 20px;
  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 10px;
  }
`

class AlertForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.alert.id,
      name: props.alert.name,
      query: props.alert.query,
      userId: props.user.id,
      frequency: props.alert.frequency,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { alertPending, history } = this.props;
    if (alertPending && !nextProps.alertPending && !nextProps.error) {
      history.push(`/dashboard/alerts`);
    }
  }

  createAlert = () => {
    const { createalert, user } = this.props;
    const { id, name, query, frequency, userId } = this.state;
    const alert = {
      name,
      query,
      frequency,
      userId,
    };
    createalert(user, alert)
  };

  updateAlert = () => {
    const { updateAlert, user } = this.props;
    const { id, name, query, frequency, userId } = this.state;
    const alert = {
      id,
      name,
      query,
      frequency,
      userId,
    };
    updateAlert(user, alert)
  };

  handleChange = (event) => {
    let name = event.target.name;
    let type = event.target.type;
    let value;
    switch (type) {
      case "checkbox":
        value = event.target.checked;
        break;
      case "file":
        const files = event.target.files;
        if (files && files[0]) {
          value = files;
        }
        break;
      default:
        value = event.target.value;
    }
    this.setState({ [name]: value });
  };

  render() {
    const { alert } = this.props;
    return (
      <Container enctype="multipart/form-data" className="tab_padd new_job_bg">
        <Header>
          <Status className="relative_top">
            {alert.searchable ? "Edit Alert:" : "Create Alert:"}
          </Status>
          <Button type="button" className="btn btn-primary hidden-xs" to="/#">
            Delete Alert
          </Button>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={alert.id ? this.updateAlert : this.createAlert}
          >
            Done
          </Button>
        </Header>
        <div>
          <div className="row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>Name</label>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  name="name"
                  placeholder="Name"
                  onChange={this.handleChange}
                  value={this.state.name}
                  required
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>Keyword, Language, Job title</label>
                <TextBox
                  type="text"
                  className="form-control form-control-lg"
                  name="query"
                  placeholder="i.e. - Java, Java Developer"
                  onChange={this.handleChange}
                  value={this.state.query}
                  required
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>Frequency</label>
                <select
                  className="form-control form-control-lg"
                  name="frequency"
                  onChange={this.handleChange}
                  value={this.state.frequency}
                >
                  <option>Select frequency</option>
                  <option>Daily</option>
                  <option>Weekly</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  alertPending: state.userAlert.pending,
  createAlert: state.userAlert.userAlerts,
  alertError: state.userAlert.errror,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      createalert: createAlertAction,
      updateAlert: updateAlertAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AlertForm);
